var map = {
	"./bs_t-3_stitch_blk.png": 544956,
	"./bs_t-3_stitch_blu.png": 761682,
	"./bs_t-3_stitch_cml.png": 762133,
	"./bs_t-3_stitch_crk.png": 161187,
	"./bs_t-3_stitch_grn.png": 380154,
	"./bs_t-3_stitch_lgd.png": 398472,
	"./bs_t-3_stitch_lsl.png": 213580,
	"./bs_t-3_stitch_nvy.png": 811268,
	"./bs_t-3_stitch_orn.png": 574834,
	"./bs_t-3_stitch_pnk.png": 843224,
	"./bs_t-3_stitch_ppl.png": 865909,
	"./bs_t-3_stitch_red.png": 542792,
	"./bs_t-3_stitch_sax.png": 461773,
	"./bs_t-3_stitch_wht.png": 436930,
	"./bs_t-3_stitch_ylw.png": 959627
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70502;